
import React, { useState } from 'react';
import { User, MapPin, CreditCard, Package, Plus, Edit, Trash2, Star } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Badge } from '@/components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Checkbox } from '@/components/ui/checkbox';
import { mockAddresses, mockSavedProducts } from '@/api/mockData';

const Profile = () => {
  const [addresses, setAddresses] = useState(mockAddresses);
  const [products, setProducts] = useState(mockSavedProducts);
  const [bankAccounts, setBankAccounts] = useState([
    {
      id: 'bank1',
      bankName: 'Vietcombank',
      accountNumber: '1234567890',
      accountName: 'Nguyễn Văn A',
      isDefault: true
    },
    {
      id: 'bank2',
      bankName: 'Techcombank',
      accountNumber: '0987654321',
      accountName: 'Nguyễn Văn A',
      isDefault: false
    }
  ]);

  const [showAddressDialog, setShowAddressDialog] = useState(false);
  const [showProductDialog, setShowProductDialog] = useState(false);
  const [showBankDialog, setShowBankDialog] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold text-foreground">Hồ sơ khách hàng</h1>
      </div>

      <Tabs defaultValue="info" className="space-y-4">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="info" className="flex items-center gap-2">
            <User className="h-4 w-4" />
            Thông tin cá nhân
          </TabsTrigger>
          <TabsTrigger value="addresses" className="flex items-center gap-2">
            <MapPin className="h-4 w-4" />
            Địa chỉ
          </TabsTrigger>
          <TabsTrigger value="products" className="flex items-center gap-2">
            <Package className="h-4 w-4" />
            Sản phẩm
          </TabsTrigger>
          <TabsTrigger value="banking" className="flex items-center gap-2">
            <CreditCard className="h-4 w-4" />
            Ngân hàng
          </TabsTrigger>
        </TabsList>

        <TabsContent value="info">
          <Card>
            <CardHeader>
              <CardTitle>Thông tin cá nhân</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="name">Họ và tên</Label>
                  <Input id="name" defaultValue="Nguyễn Văn A" />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="phone">Số điện thoại</Label>
                  <Input id="phone" defaultValue="0901234567" />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="email">Email</Label>
                  <Input id="email" type="email" defaultValue="nguyenvana@email.com" />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="company">Công ty</Label>
                  <Input id="company" defaultValue="Công ty ABC" />
                </div>
              </div>
              <Button className="bg-primary hover:bg-primary/90">
                Cập nhật thông tin
              </Button>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="addresses">
          <Card>
            <CardHeader>
              <div className="flex items-center justify-between">
                <CardTitle>Quản lý địa chỉ</CardTitle>
                <Dialog open={showAddressDialog} onOpenChange={setShowAddressDialog}>
                  <DialogTrigger asChild>
                    <Button>
                      <Plus className="h-4 w-4 mr-2" />
                      Thêm địa chỉ
                    </Button>
                  </DialogTrigger>
                  <DialogContent>
                    <DialogHeader>
                      <DialogTitle>Thêm địa chỉ mới</DialogTitle>
                    </DialogHeader>
                    <div className="space-y-4">
                      <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-2">
                          <Label>Tên</Label>
                          <Input placeholder="Tên người nhận/gửi" />
                        </div>
                        <div className="space-y-2">
                          <Label>Số điện thoại</Label>
                          <Input placeholder="Số điện thoại" />
                        </div>
                      </div>
                      <div className="space-y-2">
                        <Label>Loại địa chỉ</Label>
                        <Select>
                          <SelectTrigger>
                            <SelectValue placeholder="Chọn loại" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="sender">Người gửi</SelectItem>
                            <SelectItem value="recipient">Người nhận</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                      <div className="grid grid-cols-3 gap-4">
                        <div className="space-y-2">
                          <Label>Tỉnh/TP</Label>
                          <Select>
                            <SelectTrigger>
                              <SelectValue placeholder="Chọn tỉnh" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="hanoi">Hà Nội</SelectItem>
                              <SelectItem value="hcm">Hồ Chí Minh</SelectItem>
                            </SelectContent>
                          </Select>
                        </div>
                        <div className="space-y-2">
                          <Label>Quận/Huyện</Label>
                          <Select>
                            <SelectTrigger>
                              <SelectValue placeholder="Chọn quận" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="dongda">Đống Đa</SelectItem>
                            </SelectContent>
                          </Select>
                        </div>
                        <div className="space-y-2">
                          <Label>Phường/Xã</Label>
                          <Select>
                            <SelectTrigger>
                              <SelectValue placeholder="Chọn xã" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="langha">Láng Hạ</SelectItem>
                            </SelectContent>
                          </Select>
                        </div>
                      </div>
                      <div className="space-y-2">
                        <Label>Địa chỉ chi tiết</Label>
                        <Input placeholder="Số nhà, tên đường" />
                      </div>
                      <div className="flex items-center space-x-2">
                        <Checkbox id="default" />
                        <Label htmlFor="default">Đặt làm địa chỉ mặc định</Label>
                      </div>
                      <div className="flex justify-end space-x-2">
                        <Button variant="outline" onClick={() => setShowAddressDialog(false)}>
                          Hủy
                        </Button>
                        <Button onClick={() => setShowAddressDialog(false)}>
                          Lưu
                        </Button>
                      </div>
                    </div>
                  </DialogContent>
                </Dialog>
              </div>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                {addresses.map((address) => (
                  <div key={address.id} className="p-4 border rounded-lg">
                    <div className="flex items-start justify-between">
                      <div className="space-y-2">
                        <div className="flex items-center gap-2">
                          <span className="font-medium">{address.name}</span>
                          <Badge variant={address.type === 'sender' ? 'default' : 'secondary'}>
                            {address.type === 'sender' ? 'Người gửi' : 'Người nhận'}
                          </Badge>
                          {address.isDefault && (
                            <Badge variant="outline" className="text-yellow-600 border-yellow-600">
                              <Star className="h-3 w-3 mr-1" />
                              Mặc định
                            </Badge>
                          )}
                        </div>
                        <p className="text-sm text-muted-foreground">{address.phone}</p>
                        <p className="text-sm">
                          {address.detailedAddress}, {address.ward}, {address.district && address.district + ', '}{address.province}
                        </p>
                      </div>
                      <div className="flex space-x-2">
                        <Button size="sm" variant="outline">
                          <Edit className="h-4 w-4" />
                        </Button>
                        <Button size="sm" variant="outline">
                          <Trash2 className="h-4 w-4" />
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="products">
          <Card>
            <CardHeader>
              <div className="flex items-center justify-between">
                <CardTitle>Quản lý sản phẩm</CardTitle>
                <Dialog open={showProductDialog} onOpenChange={setShowProductDialog}>
                  <DialogTrigger asChild>
                    <Button>
                      <Plus className="h-4 w-4 mr-2" />
                      Thêm sản phẩm
                    </Button>
                  </DialogTrigger>
                  <DialogContent>
                    <DialogHeader>
                      <DialogTitle>Thêm sản phẩm mới</DialogTitle>
                    </DialogHeader>
                    <div className="space-y-4">
                      <div className="space-y-2">
                        <Label>Tên sản phẩm</Label>
                        <Input placeholder="Tên sản phẩm" />
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-2">
                          <Label>Giá trị mặc định (VNĐ)</Label>
                          <Input type="number" placeholder="0" />
                        </div>
                        <div className="space-y-2">
                          <Label>Cân nặng mặc định (kg)</Label>
                          <Input type="number" step="0.1" placeholder="0.0" />
                        </div>
                      </div>
                      <div className="space-y-2">
                        <Label>Danh mục</Label>
                        <Select>
                          <SelectTrigger>
                            <SelectValue placeholder="Chọn danh mục" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="fashion">Thời trang</SelectItem>
                            <SelectItem value="electronics">Điện tử</SelectItem>
                            <SelectItem value="books">Sách vở</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Checkbox id="frequent" />
                        <Label htmlFor="frequent">Sản phẩm thường xuyên</Label>
                      </div>
                      <div className="flex justify-end space-x-2">
                        <Button variant="outline" onClick={() => setShowProductDialog(false)}>
                          Hủy
                        </Button>
                        <Button onClick={() => setShowProductDialog(false)}>
                          Lưu
                        </Button>
                      </div>
                    </div>
                  </DialogContent>
                </Dialog>
              </div>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {products.map((product) => (
                  <div key={product.id} className="p-4 border rounded-lg">
                    <div className="flex items-start justify-between mb-2">
                      <div>
                        <h4 className="font-medium">{product.name}</h4>
                        <Badge variant="outline" className="text-xs mt-1">
                          {product.category}
                        </Badge>
                      </div>
                      {product.isFrequent && (
                        <Badge variant="secondary" className="text-xs">
                          <Star className="h-3 w-3 mr-1" />
                          Thường dùng
                        </Badge>
                      )}
                    </div>
                    <div className="space-y-1 text-sm text-muted-foreground">
                      <div>Giá trị: {product.defaultValue.toLocaleString()}đ</div>
                      <div>Cân nặng: {product.defaultWeight}kg</div>
                    </div>
                    <div className="flex space-x-2 mt-3">
                      <Button size="sm" variant="outline" className="flex-1">
                        <Edit className="h-4 w-4 mr-1" />
                        Sửa
                      </Button>
                      <Button size="sm" variant="outline">
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="banking">
          <Card>
            <CardHeader>
              <div className="flex items-center justify-between">
                <CardTitle>Thông tin ngân hàng</CardTitle>
                <Dialog open={showBankDialog} onOpenChange={setShowBankDialog}>
                  <DialogTrigger asChild>
                    <Button>
                      <Plus className="h-4 w-4 mr-2" />
                      Thêm tài khoản
                    </Button>
                  </DialogTrigger>
                  <DialogContent>
                    <DialogHeader>
                      <DialogTitle>Thêm tài khoản ngân hàng</DialogTitle>
                    </DialogHeader>
                    <div className="space-y-4">
                      <div className="space-y-2">
                        <Label>Tên ngân hàng</Label>
                        <Select>
                          <SelectTrigger>
                            <SelectValue placeholder="Chọn ngân hàng" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="vcb">Vietcombank</SelectItem>
                            <SelectItem value="tcb">Techcombank</SelectItem>
                            <SelectItem value="mb">MB Bank</SelectItem>
                            <SelectItem value="acb">ACB</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                      <div className="space-y-2">
                        <Label>Số tài khoản</Label>
                        <Input placeholder="Nhập số tài khoản" />
                      </div>
                      <div className="space-y-2">
                        <Label>Tên chủ tài khoản</Label>
                        <Input placeholder="Tên chủ tài khoản" />
                      </div>
                      <div className="flex items-center space-x-2">
                        <Checkbox id="defaultBank" />
                        <Label htmlFor="defaultBank">Đặt làm tài khoản mặc định để nhận COD</Label>
                      </div>
                      <div className="flex justify-end space-x-2">
                        <Button variant="outline" onClick={() => setShowBankDialog(false)}>
                          Hủy
                        </Button>
                        <Button onClick={() => setShowBankDialog(false)}>
                          Lưu
                        </Button>
                      </div>
                    </div>
                  </DialogContent>
                </Dialog>
              </div>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                {bankAccounts.map((account) => (
                  <div key={account.id} className="p-4 border rounded-lg">
                    <div className="flex items-start justify-between">
                      <div className="space-y-2">
                        <div className="flex items-center gap-2">
                          <span className="font-medium">{account.bankName}</span>
                          {account.isDefault && (
                            <Badge variant="outline" className="text-yellow-600 border-yellow-600">
                              <Star className="h-3 w-3 mr-1" />
                              Mặc định
                            </Badge>
                          )}
                        </div>
                        <p className="text-sm text-muted-foreground">
                          STK: {account.accountNumber}
                        </p>
                        <p className="text-sm">
                          Chủ TK: {account.accountName}
                        </p>
                      </div>
                      <div className="flex space-x-2">
                        <Button size="sm" variant="outline">
                          <Edit className="h-4 w-4" />
                        </Button>
                        <Button size="sm" variant="outline">
                          <Trash2 className="h-4 w-4" />
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Profile;
